(function () {
  'use strict';

  var config = window.HWAnalyticsConfig || {};
  var measurementId = config.measurementId;
  if (!measurementId || !/^G-[A-Z0-9]+$/.test(measurementId)) return;

  var pendingEvents = [];
  var analyticsAllowed = false;
  var tagLoaded = false;
  var privacyChecks = 0;
  var maxPrivacyChecks = 40;
  var themeRole =
    window.Shopify && window.Shopify.theme ? cleanText(window.Shopify.theme.role, 30) : '';

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500
  });

  function cleanText(value, maxLength) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, maxLength || 100);
  }

  function pageContext(node) {
    var section = node && node.closest ? node.closest('[id^="shopify-section-"]') : null;
    return {
      page_type: cleanText(config.pageType, 40),
      page_locale: cleanText(config.locale, 20),
      theme_role: themeRole,
      cta_position: cleanText(
        (node && node.getAttribute && node.getAttribute('data-cta-position')) ||
          (section && section.id) ||
          'unknown',
        80
      )
    };
  }

  function publishShopifyEvent(eventName, params) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('hw_' + eventName, params);
      }
    } catch (error) {
      // Tracking must never interrupt the inquiry path.
    }
  }

  function dispatchEvent(eventName, params) {
    publishShopifyEvent(eventName, params);
    if (!analyticsAllowed || !tagLoaded) {
      pendingEvents.push({ name: eventName, params: params });
      return;
    }
    window.gtag('event', eventName, params);
  }

  function flushEvents() {
    if (!analyticsAllowed || !tagLoaded) return;
    while (pendingEvents.length) {
      var event = pendingEvents.shift();
      window.gtag('event', event.name, event.params);
    }
  }

  function loadTag() {
    if (tagLoaded || !analyticsAllowed) return;
    tagLoaded = true;

    window.gtag('consent', 'update', { analytics_storage: 'granted' });
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      send_page_view: true,
      debug_mode:
        Boolean(config.designMode) ||
        Boolean(themeRole && themeRole !== 'main' && themeRole !== 'live') ||
        new URLSearchParams(window.location.search).has('preview_theme_id')
    });

    if (!document.getElementById('hw-ga4-script')) {
      var script = document.createElement('script');
      script.id = 'hw-ga4-script';
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
      script.onload = flushEvents;
      document.head.appendChild(script);
    } else {
      flushEvents();
    }
  }

  function readPrivacy() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
      analyticsAllowed = Boolean(privacy.analyticsProcessingAllowed());
      if (analyticsAllowed) loadTag();
      return true;
    } catch (error) {
      return false;
    }
  }

  function waitForPrivacy() {
    if (readPrivacy() || privacyChecks >= maxPrivacyChecks) return;
    privacyChecks += 1;
    window.setTimeout(waitForPrivacy, 250);
  }

  function initializePrivacy() {
    if (
      window.Shopify &&
      typeof window.Shopify.loadFeatures === 'function'
    ) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error && readPrivacy()) return;
          waitForPrivacy();
        }
      );
      return;
    }
    waitForPrivacy();
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event.detail || {};
    analyticsAllowed = Boolean(detail.analyticsAllowed);
    if (analyticsAllowed) {
      loadTag();
    } else if (tagLoaded) {
      window.gtag('consent', 'update', { analytics_storage: 'denied' });
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var wechat = target.closest(
      '[data-fcs-wechat-btn], [data-mobile-wechat-btn], [data-mobile-wechat-open], [data-mobile-wechat-trigger], [data-mobile-wechat-save]'
    );
    if (wechat) {
      var wechatParams = pageContext(wechat);
      wechatParams.contact_method = 'wechat';
      wechatParams.lead_tier = 'auxiliary';
      wechatParams.interaction = wechat.hasAttribute('data-mobile-wechat-save') ? 'qr_save' : 'qr_open';
      dispatchEvent('contact_intent', wechatParams);
      return;
    }

    var link = target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var channel = (link.getAttribute('data-cta-channel') || '').toLowerCase();
    var isWhatsApp =
      channel === 'whatsapp' ||
      /(?:https?:\/\/)?(?:api\.)?whatsapp\.com\//i.test(href) ||
      /(?:https?:\/\/)?wa\.me\//i.test(href);

    if (isWhatsApp) {
      var whatsappParams = pageContext(link);
      whatsappParams.contact_method = 'whatsapp';
      whatsappParams.lead_tier = 'primary';
      whatsappParams.cta_label = cleanText(
        link.getAttribute('data-cta-label') || link.getAttribute('aria-label') || link.textContent,
        100
      );
      dispatchEvent('generate_lead', whatsappParams);
      return;
    }

    if (/^mailto:/i.test(href)) {
      var emailParams = pageContext(link);
      emailParams.contact_method = 'email';
      emailParams.lead_tier = 'auxiliary';
      emailParams.cta_label = cleanText(link.getAttribute('aria-label') || link.textContent, 100);
      dispatchEvent('contact_intent', emailParams);
    }
  });

  function trackSuccessfulContactForm() {
    var marker = document.querySelector('[data-hw-contact-form-success]');
    var storageKey = 'hw-contact-form-success:' + window.location.pathname;

    try {
      if (!marker) {
        window.sessionStorage.removeItem(storageKey);
        return;
      }
      if (window.sessionStorage.getItem(storageKey)) return;
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      if (!marker) return;
    }

    var formParams = pageContext(marker);
    formParams.contact_method = 'form';
    formParams.lead_tier = 'auxiliary';
    formParams.form_id = cleanText(marker.getAttribute('data-hw-contact-form-id'), 80);
    dispatchEvent('contact_form_success', formParams);
  }

  initializePrivacy();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackSuccessfulContactForm, { once: true });
  } else {
    trackSuccessfulContactForm();
  }
})();
